// extracted by mini-css-extract-plugin
export default {"architectureDiagram":"KubernetesCheatSheet_architectureDiagram__j5JWv"};